<header class="msg-header">

  <div class="msg-header-toolbar">
    <div class="msg-header-actions msg-header-actions--start">
      @if (!isReadOnly() && message?.id) {
        <button
          mat-stroked-button
          type="button"
          class="header-action"
          [disabled]="!canClose()"
          (click)="onClose()"
          aria-label="Släck">
          <mat-icon>visibility_off</mat-icon>
          Släck
        </button>
      }
      @if (message?.id && !isReadOnly()) {
        <button
          mat-stroked-button
          type="button"
          class="header-action header-action--icon-only"
          (click)="onUseAsTemplate()"
          matTooltip="Kopiera"
          matTooltipPosition="below"
          aria-label="Kopiera">
          <mat-icon>filter_none</mat-icon>
        </button>
      }
      @if (!isReadOnly() && showButton) {
        <button
          mat-stroked-button
          type="button"
          class="header-action header-action--icon-only"
          (click)="openNewWindow()"
          matTooltip="Öppna i nytt fönster"
          matTooltipPosition="below"
          aria-label="Öppna i nytt fönster">
          <mat-icon>open_in_new</mat-icon>
        </button>
      }
    </div>

    <div class="msg-header-title-wrap">
      @if (message?.id) {
        <h2 class="msg-header-title">{{ displayHeading }}</h2>
      }
      @if (!message?.id) {
        <h2 class="msg-header-title">Nytt meddelande</h2>
      }
    </div>

    <div class="msg-header-actions msg-header-actions--end">
      @if (!isReadOnly() && message?.id && canEdit()) {
        <button
          mat-stroked-button
          type="button"
          class="header-action"
          (click)="onKlart()">
          Klart
        </button>
      }
      @if (!message?.id && !isReadOnly()) {
        <button
          mat-raised-button
          color="primary"
          type="button"
          class="header-action header-action--primary"
          [disabled]="!isFormValid()"
          (click)="onSave()">
          <mat-icon>send</mat-icon>
          Skicka
        </button>
      }
      @if (message?.id && !isReadOnly()) {
        <button
          mat-raised-button
          color="primary"
          type="button"
          class="header-action header-action--primary"
          [disabled]="!canUpdate()"
          (click)="onSave()">
          <mat-icon>loop</mat-icon>
          Uppdatera
        </button>
      }
    </div>
  </div>

  @if (message) {
    <div class="msg-header-meta-row">
      <div class="msg-header-meta-side msg-header-meta-side--start">
        <mat-tab-group
          class="message-type-tabs"
          [class.message-type-tabs--readonly]="!isNewMessage"
          [selectedIndex]="isNewMessage ? (showApp ? 0 : 1) : 0"
          (selectedIndexChange)="onMessageTypeTabChange($event)"
          mat-stretch-tabs="false"
          animationDuration="0ms"
          disableRipple>
          @if (isNewMessage || showApp) {
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon aria-hidden="true">phone_android</mat-icon>
                Appen
              </ng-template>
            </mat-tab>
          }
          @if (isNewMessage || !showApp) {
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon aria-hidden="true">train</mat-icon>
                Tåg i Tid
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
      @if (message.id) {
        <div class="msg-header-meta-center">
          <div class="version-nav">
            <button
              mat-stroked-button
              type="button"
              class="header-action header-action--icon-only header-action--square"
              [disabled]="message.ver == 1"
              (click)="onVersionChange(false)"
              aria-label="Föregående version">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="version-badge">Version {{ message.ver }}</span>
            <button
              mat-stroked-button
              type="button"
              class="header-action header-action--icon-only header-action--square"
              [disabled]="message.ver >= numberOfVersions"
              (click)="onVersionChange(true)"
              aria-label="Nästa version">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
          <span class="meta-text">
            Senast ändrad:
            <strong>{{ message.updatedAt | date: 'dd MMM yyyy HH:mm' }}</strong>
          </span>
        </div>
      }
      @if (message.id) {
        <div class="msg-header-meta-side msg-header-meta-side--end" aria-hidden="true"></div>
      }
    </div>
  }

  @if (laterMessageExists) {
    <p class="msg-header-alert">
      Det finns en nyare version av meddelandet!
    </p>
  }

</header>
